// hooks/useCitiesByState.js
import { useQuery } from "@tanstack/react-query";
import { getCitiesByState } from "../Services/GetLocation";

export const useCitiesByState = (country, state) => {
    return useQuery({
        queryKey: ["cities", country, state],
        queryFn: () => getCitiesByState(country, state),
        enabled: !!country && !!state,
        staleTime: 5 * 60 * 1000,
    });
};
